<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-truck mr-2" />Barang Masuk - Batch Pengiriman</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Nama Cabang">
                        <b-form-input id="branch-input" v-model="filter.branch" maxlength="5" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Jumlah Proses">
                        <b-form-select id="processed-select" v-model="filter.processed" :options="optProcessed" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Aksi">
                        <b-button id="search-button" variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
                id="batch-table"
            >
                <template v-slot:empty>
                    Tidak ada data batch.
                </template>
                <template v-slot:cell(action)="row">
                    <b-link :to="'/barang-masuk/' + $route.params.deliveryId + '/' + row.item.id">
                        <b-button :id="`action-btn-${row.item.id}`" size="sm" variant="primary" v-b-tooltip.hover.top title="Detail">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </b-link>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'barang-masuk-batch-list',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                branch: "",
                processed: -1
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "branch", label: "Cabang", sortable: true },
                { key: "total_item", label: "Total Item", sortable: true },
                { key: "item_processed", label: "# Item Sudah Diproses", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optProcessed: [
                { value: -1, text: "-- Semua --" },
                { value: 1, text: "Terproses Semua" },
                { value: 0, text: "Belum Terproses Semua" },
            ]

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.branch)) {
                param += "&filterBranch=" + this.filter.branch
            }

            if(this.filter.processed != -1) {
                param += "&filterProcessed=" + this.filter.processed
            }
            
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("delivery/" + this.$route.params.deliveryId + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listBatchFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        }

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listBatchFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listBatchFilter"))
        }
        this.init()
    }
}
</script>
